export default "skymp5-front/95d06dca1659c8554ad240bd028918b6.gif";